::ng-deep lib-app-transaction-overview{display:flex;flex-grow:1}::ng-deep lib-app-transaction-overview .pos-relative{flex-grow:1;height:auto}
/*# sourceMappingURL=transaction-overview.component-MXFKUJSX.css.map */
